
let SysManageRoutes = [
  {
    // 机构资料管理
    path: '1101',
    name: '1101',
    component: () => import('@/pages/SysManage/InstitutionInfoManage/InstitutionInfoManage')
  },
  {
    // 机构参数
    path: '1102',
    name: '1102',
    component: () => import('@/pages/SysManage/InstitutionParam/InstitutionParam')
  },
  {
    // 系统参数
    path: '1201',
    name: '1201',
    component: () => import('@/pages/SysManage/SystemParameter/SystemParameter')
  },
  {
    // 编码维护
    path: '1301',
    name: '1301',
    component: () => import('@/pages/SysManage/CodeTableManage/CodeTableManage')
  },
  // {
  //   path: '1401',
  //   name: '1401',
  //   component: () => import('@/pages/SysManage/HolidayManage/HolidayManage')
  // },
  {
    // 工作日管理
    path: '1401',
    name: '1401',
    component: () => import('@/pages/SysManage/WorkDayManage/WorkDayManage')
  },
  {
    // 跨区应用设置
    path: '1501',
    name: '1501',
    component: () => import('@/pages/SysManage/TransregionalSetting/TransregionalSetting')
  },
  {
    // 支付渠道基础信息
    path: '1601',
    name: '1601',
    component: () => import('@/pages/SysManage/PaymentChannelInformation/PaymentChannelInformation')
  },
  {
    // 支付渠道应用配置
    path: '1602',
    name: '1602',
    component: () => import('@/pages/SysManage/PaymentApply/PaymentApply')
  },
  {
    // 角色管理
    path: '1701',
    name: '1701',
    component: () => import('@/pages/SysManage/RoleManage/RoleManage')
  },
  {
    // 操作员
    path: '1702',
    name: '1702',
    component: () => import('@/pages/SysManage/UserManage/UserManage')
  },
  {
    // 审计日志
    path: '1703',
    name: '1703',
    component: () => import('@/pages/SysManage/AuditLog/AuditLog')
  }
]

export {
  SysManageRoutes
}



// WEBPACK FOOTER //
// ./src/router/SysManageRoutes.js